import React from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Why Atharva', href: '#why' },
  { label: 'How it works', href: '#how' },
  { label: 'For you', href: '#for-you' },
  { label: 'Impact', href: '#impact' },
  { label: 'Projects', href: '#projects' },
  { label: 'Get Started', href: '#cta' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  const smoothScroll = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-gray-800 bg-gray-950 py-12 text-gray-400" aria-label="Site footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <div className="h-10 w-10 flex-shrink-0 overflow-hidden">
                <img src="/atharva-logo.png" alt="Atharva logo" className="h-full w-full object-contain" />
              </div>
              <div>
                <div className="text-lg font-bold leading-none text-white">Atharva</div>
                <div className="text-[10px] font-medium uppercase tracking-widest text-green-500">
                  Sustainable Agritech
                </div>
              </div>
            </div>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-gray-500">
              A grassroots agritech initiative empowering rural India through a direct-to-buyer
              marketplace, sustainable energy, and cultural revival.
            </p>
          </div>

          <div>
            <div className="mb-3 text-xs font-semibold uppercase tracking-widest text-gray-500">Navigation</div>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => smoothScroll(e, link.href)}
                    className="text-sm transition-colors hover:text-green-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="mb-3 text-xs font-semibold uppercase tracking-widest text-gray-500">Projects</div>
            <ul className="space-y-2">
              <li>
                <Link to="/signup" className="text-sm transition-colors hover:text-green-400">
                  🌾 Agri-Marketplace
                </Link>
              </li>
              <li>
                <Link to="/projects/biogas" className="text-sm transition-colors hover:text-green-400">
                  ⚗️ Village Biogas
                </Link>
              </li>
              <li>
                <Link to="/projects/art" className="text-sm transition-colors hover:text-green-400">
                  🎨 Village Art &amp; Culture
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-gray-800 pt-6 sm:flex-row">
          <p className="text-xs text-gray-600">© {year} Atharva. All rights reserved.</p>
          <p className="text-xs text-gray-600">Built with 💚 for a sustainable India</p>
        </div>
      </div>
    </footer>
  );
}
